import { Icon, cn } from "@sagot/ui";

const MARK: Record<string, { text: string; className: string }> = {
  gcash: { text: "GCash", className: "bg-brand-700 text-white" },
  maya: { text: "Maya", className: "bg-mint-700 text-white" },
  card: { text: "CARD", className: "bg-ink-950 text-white" },
  paypal: { text: "PayPal", className: "bg-brand-700 text-white" },
};

/** Small payment-method chip (mockup: VISA / GCash / Maya / bank icon). Decorative: the label sits beside it. */
export function MethodMark({ type, brand, small }: { type: string; brand?: string | null; small?: boolean }) {
  const size = small ? "h-7 w-11 text-[10px]" : "h-8 w-12 text-[11px]";
  if (type === "bank") {
    return (
      <span aria-hidden="true" className={cn("inline-flex shrink-0 items-center justify-center rounded-sm bg-sunken text-fg-muted", size)}>
        <Icon name="building" className="size-4" />
      </span>
    );
  }
  const mark = MARK[type] ?? MARK.card;
  const text = type === "card" && brand && brand !== "card" ? brand.toUpperCase() : (mark?.text ?? "");
  return (
    <span aria-hidden="true" className={cn("inline-flex shrink-0 items-center justify-center rounded-sm font-extrabold tracking-wider", size, mark?.className)}>
      {text.slice(0, 6)}
    </span>
  );
}
